// extracted by mini-css-extract-plugin
module.exports = {"base":"ScreenSection_base__mo5sV","base_theme_dark":"ScreenSection_base_theme_dark__1DVYr","baseThemeDark":"ScreenSection_base_theme_dark__1DVYr","base_theme_light":"ScreenSection_base_theme_light__2vNBE","baseThemeLight":"ScreenSection_base_theme_light__2vNBE","background":"ScreenSection_background__1FByC","content":"ScreenSection_content__2u9WT","content_nolimit":"ScreenSection_content_nolimit__tb3kB","contentNolimit":"ScreenSection_content_nolimit__tb3kB"};
    if(module.hot) {
      // 1586964020535
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  